import { Controller } from "../../Controller";
import {
    ListarTodosStatusEscrituraService,
    SalvarStatusEscrituraVendaService,
} from "../../../Services/Cobranca/StatusEscritura/StatusEscrituraServices";
import { IStatusEscritura } from "../../../Interfaces/Cobranca/StatusEscritura/StatusEscrituraInterfaces";

export async function ListarTodosStatusEscrituraController() {
    return Controller(ListarTodosStatusEscrituraService());
}

export async function SalvarStatusEscrituraVendaController(
    idCaso: number,
    lstStatusEscritura: Array<IStatusEscritura>
) {
    return Controller(
        SalvarStatusEscrituraVendaService(idCaso, lstStatusEscritura)
    );
}
